var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var TimedChangbleFrame = /** @class */ (function (_super) {
    __extends(TimedChangbleFrame, _super);
    function TimedChangbleFrame(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { currentChildIndex: 0 };
        return _this;
    }
    TimedChangbleFrame.prototype.componentDidMount = function () {
        this.setNextFrame(this.state.currentChildIndex);
    };
    TimedChangbleFrame.prototype.setNextFrame = function (index) {
        var _this = this;
        /* istanbul ignore next */
        if (index === this.props.childrenData.length) {
            /* istanbul ignore next */
            return;
        }
        else {
            setTimeout(function () {
                var handler = _this.props.childrenData[index].timedOutHandler;
                handler && handler();
                _this.setNextFrame(index + 1);
            }, this.props.childrenData[index].timeOutMili);
            this.setState({ currentChildIndex: index });
        }
    };
    TimedChangbleFrame.prototype.render = function () {
        return (this.props.children && this.props.children[this.state.currentChildIndex]);
    };
    return TimedChangbleFrame;
}(React.Component));
export { TimedChangbleFrame };
//# sourceMappingURL=TimedChangbleFrame.js.map